import  FetchData, { } from '../../client';
import {getBranchId, getHospitalId, getLoginID}  from '../../../auth';
import formapimodaltotalrevenuePagination from '../../domains/totalrevenueview';
import formapimodaltotalrevenueview from '../../domains/totalrevenueview/revenueViews';

  const FetchTotalRevenueDetails = async (inputData) => {
    try {
      inputData.doctorid = getLoginID();
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
      const result = await FetchData("midoc_getdoctortotalrevenue", inputData);
      //console.log(result, "Total Revenue Result")
      if (result.output) {
        var finalOutput = formapimodaltotalrevenuePagination(result.output)
        }

        //console.log(finalOutput, "finalOUTPUT")
      return finalOutput;
  
    } catch (error) {
      console.error('Error fetching data in forms.js:', error);
      throw error;
    }
  };

  const FetchFilteredTotalRevenueList = async (inputData) => {
    try{
      inputData.branchid = getBranchId();
      inputData.hospitalid = getHospitalId()
        // inputData.loginid = getLoginID();
        const result = await FetchData('midoc_getdoctortotalrevenue', inputData);
        // console.log(result, "Filtered Total Revenue Result");

        if(result.output.data){
            var data = formapimodaltotalrevenueview(result.output.data);

            let count = result?.output?.count;
            let pageno = result?.output?.pageno;
            let pagesize = result?.output?.pagesize;
            var finalOutput = {
                data,
                count,
                pageno,
                pagesize
            }
            // console.log(finalOutput, "final OUtuput");
            return finalOutput;
        }

    } catch(error) {
        console.error('Error fetching data in forms.js:', error);
        throw error;
    }
}

  

export {FetchTotalRevenueDetails, FetchFilteredTotalRevenueList};
